import { UserAssessmentBase } from "domain/model/base";

export default class UserAssessment extends UserAssessmentBase {};
